import { useCallback, useRef } from "react";

/** Zwei horizontale Scroll-Container auf derselben Position halten. */
export function useSyncedHorizontalScroll() {
  const primaryRef = useRef<HTMLDivElement>(null);
  const secondaryRef = useRef<HTMLDivElement>(null);
  const locking = useRef<"primary" | "secondary" | null>(null);

  const syncFrom = useCallback((source: "primary" | "secondary") => {
    const fromEl = source === "primary" ? primaryRef.current : secondaryRef.current;
    const toEl = source === "primary" ? secondaryRef.current : primaryRef.current;
    if (!fromEl || !toEl) return;
    if (locking.current && locking.current !== source) return;
    if (toEl.scrollLeft === fromEl.scrollLeft) return;
    locking.current = source;
    toEl.scrollLeft = fromEl.scrollLeft;
    requestAnimationFrame(() => {
      locking.current = null;
    });
  }, []);

  return {
    primaryRef,
    secondaryRef,
    onPrimaryScroll: () => syncFrom("primary"),
    onSecondaryScroll: () => syncFrom("secondary"),
  };
}
